import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="expenses--image-preview"
export default class extends Controller {
  static targets = ["previewContainer", "previewImage"]

  connect() {}

  // Handle file upload - only processes if it's an image
  handleFile(file, objectUrl) {
    if (file.type.startsWith("image/")) {
      this.showPreview(file, objectUrl)
    }
  }

  // Show preview from a file object
  showPreview(file, objectUrl) {
    const container = this.previewContainerTarget
    const img = this.previewImageTarget

    if (!container || !img) return

    // Store object URL for cleanup
    this.cleanupObjectUrl()
    if (objectUrl.startsWith("blob:")) {
      this.currentObjectUrl = objectUrl
    }

    // Update existing image element
    img.src = objectUrl
    img.alt = file.name

    // Update container state to show image (CSS handles visibility)
    container.className = container.className.replace(/document-preview-container--\w+/, "")
    container.classList.add("document-preview-container", "document-preview-container--image")
  }

  // Show preview from URL (for server-rendered images)
  showPreviewFromUrl(imageUrl, filename) {
    const container = this.previewContainerTarget
    if (!container) return

    const img = this.previewImageTarget
    if (img) {
      img.src = imageUrl
      img.alt = filename
      container.classList.remove("document-preview-empty")
      container.classList.add("document-preview-container")
    }
  }

  cleanupObjectUrl() {
    if (this.currentObjectUrl?.startsWith("blob:")) {
      try {
        URL.revokeObjectURL(this.currentObjectUrl)
      } catch (_e) {
        // Ignore errors
      }
      this.currentObjectUrl = null
    }
  }

  showEmptyPreview() {
    const container = this.previewContainerTarget
    if (!container) return

    container.className = container.className.replace(/document-preview-container--\w+/, "")
    container.classList.add("document-preview-container", "document-preview-container--empty")
  }

  disconnect() {
    // Clean up any object URLs when controller disconnects
    this.cleanupObjectUrl()
  }
}
